module.exports = __webpack_public_path__ + "img/antes_despues_181.af43d3a4.png";